import instantsearch from 'instantsearch.js/es'
import algoliasearch from 'algoliasearch/lite'

import customHits from '../utils/algolia/customHits'
import customRefinementList from '../utils/algolia/customRefinementList'
import { configure, pagination, stats } from 'instantsearch.js/es/widgets'

export default {
  name: 'algolia-list',

  ui: {
    results: '[js-algolia-list-results]',
    pagination: '[js-algolia-list-pagination]',
    filtersType: '[js-algolia-list-filters-type]',
    filtersExpertise: '[js-algolia-list-filters-expertise]',
    stats: '[js-algolia-list-stats]',
  },

  componentDidMount () {
    const indexName = `${config.algolia.env}_pages`

    this.searchClient = algoliasearch(
      config.algolia.applicationID,
      config.algolia.apiKey,
    )

    this.search = instantsearch({
      indexName: `${indexName}`,
      searchClient: this.searchClient,
      routing: {
        stateMapping: {
          stateToRoute (uiState) {
            const indexUiState = uiState[indexName]

            return {
              type: indexUiState.refinementList && indexUiState.refinementList.type,
            }
          },
          routeToState (routeState) {
            return {
              [indexName]: {
                refinementList: {
                  type: routeState.type,
                },
              },
            }
          },
        },
      },
    })

    let configureParams = [
      `locale:${config.locale}`,
      'visible:true',
    ]

    if (this.props.isAdherent) {
      configureParams = [
        `locale:${config.locale}`,
        'visible:true',
        'isMemberOnly:true',
      ]
    }

    this.search.addWidgets([
      // global
      configure({
        hitsPerPage: this.props.type === 'photo' ? 12 : 11,
        facetFilters: configureParams,
        filters: `groupType:${this.props.type}`,
      }),
      pagination({
        container: this.ui.pagination,
        showFirst: false,
        showLast: false,
        templates: {
          next: '<svg width="9" height="15" viewBox="0 0 9 15"><path d="M7.636 1 1.272 7.364l6.364 6.364" stroke="#312B69" stroke-width="2" fill="none"/></svg>',
          previous: '<svg width="9" height="15" viewBox="0 0 9 15"><path d="M7.636 1 1.272 7.364l6.364 6.364" stroke="#312B69" stroke-width="2" fill="none"/></svg>',
        },
      }),
      // results
      customHits({
        container: this.ui.results,
        type: this.props.type,
        searchInstance: this.search,
        /* eslint-disable-next-line */
        userConnected: this.props.userConnected === 'true' ? true : false
      }),
      customRefinementList({
        container: this.ui.filtersExpertise,
        attribute: 'expertise',
        sortBy: ['name'],
        isType: false,
        limit: 20,
        operator: 'and',
      }),
    ])

    if (this.ui.filtersType) {
      this.search.addWidgets([
        // filters
        customRefinementList({
          container: this.ui.filtersType,
          attribute: 'type',
          sortBy: ['name'],
          isType: true,
        }),
      ])
    }

    if (this.ui.stats) {
      this.search.addWidgets([
        stats({
          container: this.ui.stats,
          templates: {
            text (data, { html }) {
              let count = ''

              if (data.hasManyResults) {
                count += `<span id="algo-id">${data.nbHits} résultats</span>`
              } else if (data.hasOneResult) {
                count += '<span id="algo-id">1 résultat</span>'
              } else {
                count += '<span id="algo-id">0 résultat</span>'
              }

              return html`${count}`
            },
          },
        }),
      ])
    }

    this.search.start()
    this.search.on('render', () => {
      const searchState = this.search.helper.state
      if (searchState.filters === 'groupType:photo' && searchState.disjunctiveFacetsRefinements.expertise.length === 0) {
        document.getElementById('algo-id').remove()
      }
    })
  },
}
